import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as ArrowRight } from '../../../../assets/icons/arrow-right.svg';
import { ReactComponent as Line } from '../../../../assets/icons/line-configurator.svg';
import { BabylonActions } from '../../../../babylon';
import { useStableRoutes } from '../../../../hooks/stable';
import * as log from '../../../../utils/log';
import IconWithText from '../../../IconWithText/IconWithText';
import Paragraph from '../../../Typography/Paragraph/Paragraph';
import styles from './SingleConfiguratorView.module.scss';
const SingleConfiguratorView = ({ image, name, amount, desc, className, id, activateTab }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { configuratorRoute } = useStableRoutes();
    const [disabled, setDisabled] = useState(false);
    const params = useParams();
    useEffect(() => {
        params.stakeId && setDisabled(true);
    }, [params]);
    const handleNavigate = () => {
        if (disabled)
            return;
        log.debug('Go to Configurator', id, activateTab);
        navigate(`${configuratorRoute}`, {
            state: { id, activeTab: activateTab }
        });
        BabylonActions.StablesGoToConfiguratorView();
    };
    return (_jsxs("div", Object.assign({ className: cn(styles.element, className) }, { children: [_jsxs("div", { children: [_jsx("div", Object.assign({ className: styles.image }, { children: _jsx("img", { alt: '', src: image }) })), _jsxs("div", Object.assign({ className: 'd-flex' }, { children: [_jsxs("div", Object.assign({ className: cn(styles.box, 'd-flex flex-column') }, { children: [_jsx(Paragraph, { title: name }), _jsx(Paragraph, { className: styles.wordWrap, color: 'grey', fontFamily: 'urbanist', size: 1, title: desc })] })), _jsx(Line, { className: styles.line }), _jsxs("div", Object.assign({ className: cn(styles.box, 'd-flex flex-column') }, { children: [_jsx(Paragraph, { title: amount }), _jsx(Paragraph, { color: 'grey', fontFamily: 'urbanist', size: 1, title: t('in_stable') })] }))] }))] }), _jsx("div", Object.assign({ className: 'd-flex' }, { children: _jsx(IconWithText, { onClick: handleNavigate, className: cn(styles.arrowRight, disabled && styles['isDisabled']), iconRight: _jsx(ArrowRight, {}), text: t('configure') }) }))] })));
};
export default SingleConfiguratorView;
